export const goBackWithFallback = (history, altRoute) => {
    if (history.length > 1) {
        history.goBack();
    }
    else {
        history.push(altRoute);
    }
};
export const getBackLinkProps = (history, altRoute) => {
    if (history.length > 1) {
        return {
            onClick: () => history.goBack(),
        };
    }
    return { to: altRoute };
};
//# sourceMappingURL=history.js.map